interface PatientBillOfRightsData {
  heading?: string;
  content?: string | React.ReactNode;
}
const patientBillOfRightsPairs: [string, React.ReactNode][] = [
  [
    "",
    <>
      <p className="mb-1">
        The perceptions and expectations of patients need to be aligned with
        what the doctors, medical staff and Defy Medical can realistically
        offer. It is important that these services, facilities, treatment, and
        applicable rules and regulations are explicitly stated rather than
        assumed to be understood by those who come to Defy Medical for
        treatment. Once these are stated, it also becomes easier for Defy
        Medical to receive constructive feedback and suggestions on the same.
      </p>
    </>,
  ],
  [
    "1. Patient's Code of Conduct",
    <>
      <p className="mb-1">
        Patients are responsible for their own personal and environmental
        well-being. The following code of conduct emphasizes the
        responsibilities of a patient while seeking medical care at Defy
        Medical.
      </p>
      <p className="mb-1">As a patient:</p>
      <ul className="list-disc pl-8 mt-0 mb-4 space-y-1 marker:text-black text-gray-600">
        <li>
          You should provide the doctor with accurate and complete information
          about your medical history, past illnesses, allergies, current
          illnesses, and medications.
        </li>
        <li>You should report changes in your medical condition.</li>
        <li>
          You should ask for clarity if the doctor's prescription and diagnosis
          seem unclear.
        </li>
        <li>You should follow the doctor's treatment plan.</li>
        <li>You should pay your medical bills promptly.</li>
        <li>You should follow Defy Medical rules and regulations.</li>
        <li>
          You should have realistic expectations of what the doctor can do for
          you.
        </li>
        <li>
          You should help your doctor help you; if something isn't working, be
          clear and the doctor can advise alternative care.
        </li>
        <li>
          You should participate actively in your own medical care (in terms of
          awareness and preventions).
        </li>
        <li>
          You should treat the doctors and staff with respect and dignity.
          Verbal abuse will result in immediate discharge.
        </li>
      </ul>
    </>,
  ],
  [
    "2. Patient's Bill of Rights",
    <>
      <p className="mb-1">
        This lists the basic rights that any patient has with respect to his /
        her own treatment, with respect to Defy Medical, and in relation to
        information to be made available. By publicly displaying such a list of
        rights, Defy Medical and doctors display their commitment towards the
        health and well-being of the patients who come there for treatment, and
        help to build and re-affirm the patient's trust and faith in the doctor
        and in the medical system.
      </p>
      <p>
        Each medical facility should display the following Patient's Bill of
        Rights.
      </p>
    </>,
  ],
  [
    "3. Rights of a Patient related to the treatment",
    <>
      <ul className="list-disc pl-8 mt-0 mb-4 space-y-1 marker:text-black text-gray-600">
        <li>To be treated with dignity.</li>
        <li>
          To obtain from the doctor complete information concerning the
          diagnosis, treatment, and prognosis in a language the patient can
          understand.
        </li>
        <li>
          To receive necessary information from the doctor such as long-term
          effects, side effects etc., before giving any prior consent to a
          medical procedure and/or treatment.
        </li>
        <li>To know and understand Defy Medical's procedures involved.</li>
        <li>To be informed about how much time the treatment will take. </li>
        <li>
          To be informed about what the expected overall cost of treatment will
          be.
        </li>
        <li>To be informed about the necessary documentation.</li>
        <li>To receive prompt and courteous care.</li>
        <li>
          To be given, at the time of discharge, all details of the disease,
          treatment, and the needed follow-up.
        </li>
        <li>
          To refuse the suggested treatment and be informed of the medical
          consequences thereof.
        </li>
        <li>
          To be confident my Private Health Information is properly safeguarded
          and guaranteed private.
        </li>
      </ul>
    </>,
  ],
  [
    "4. Rights of a Patient related to Defy Medical",
    <>
      <ul className="list-disc pl-8 mt-0 mb-4 space-y-1 marker:text-black text-gray-600">
        <li>
          To have a list of exact services available and corresponding fees.
        </li>
        <li>
          To have the contact information of the responsible person to register
          a complaint or give feedback.
        </li>
        <li>
          To educational information about medical issues via wellness coaching
          sessions, etc.
        </li>
        <li>
          To have my Private Health Information properly safeguarded until
          destroyed.
        </li>
      </ul>
    </>,
  ],
];
export const patientBillOfRightsData: PatientBillOfRightsData[] =
  patientBillOfRightsPairs.map(([heading, content]) => ({
    heading,
    content,
  }));
